import * as React from 'react';
import { HashRouter as Router, Route } from 'react-router-dom';
import { Col, Container} from 'reactstrap';
import {
  Nav,
  Navbar,
  NavbarBrand,
  NavItem,
  NavLink,
  Row } from 'reactstrap';

import './App.css';
import Create from './Create';
import DisplaySecret from './DisplaySecret';


class App extends React.Component {
  public render() {
    return (
      <Router>
        <div>
          <div className="App">
            <Navbar color="light">
            <NavbarBrand href="/"> 
                <img
                  alt=""
                  src="/bode250.png"
                  width="75"
                  height="75"
                  className="d-inline-block align-top"
                />
                {'Secret Share'}
              </NavbarBrand>
              <Nav className="ml-auto">
                <NavItem>
                  <NavLink href="https://bode.one">back to bode.one</NavLink>
                </NavItem>
              </Nav>
          </Navbar>
          </div>
          <Container className="margin">
            <Row>
              <Col ml="auto">
                <Route path="/" exact={true} component={Create} />
                <Route
                  exact={true}
                  path="/s/:key/:password"
                  component={DisplaySecret}
                />
                <Route exact={true} path="/s/:key" component={DisplaySecret} />
              </Col>
            </Row>
          </Container> 
        </div>
        <footer className="footer">
          <p>&copy; {new Date().getFullYear()} <a href="https://bode.one"> Bode.one </a></p>
        </footer>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx